import { render, staticRenderFns } from "./CoursePanel.vue?vue&type=template&id=7b3221a0&scoped=true&"
import script from "./CoursePanel.vue?vue&type=script&lang=js&"
export * from "./CoursePanel.vue?vue&type=script&lang=js&"
import style0 from "./CoursePanel.vue?vue&type=style&index=0&id=7b3221a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3221a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VHover,VIcon,VImg,VLayout})
